export default __webpack_public_path__ + "static/DSC_0005-daa56dab7651a0567430347f67e2dcf1.jpg";